<template lang="pug">
  div
    div(
      v-if="verificarVtnFinalizada() && $route.name === 'gerenciamento-daes'"
    ).card-info
      el-row
        div.d-flex.tb
          div.column
            p.verde-text.text-aviso {{vtn.titulo}}
            p.verde-text.text-between {{vtn.mensagem}}
          div.botao
            el-button.green.textButtonBreak(
              v-if="vtn.vencido"
              tipo="success",
              @click="reemite()"
            )
              span.center
                i.fal.fa-credit-card
                | &nbsp Reemitir DAE
            el-button.green.textButtonBreak(
              tipo="success",
              v-if="hasVtn"
              @click="goLink(false)"
            )
              span.center
                i.fal.fa-credit-card
                | &nbsp {{vtn.mensagemBotao}}
    div(
    v-if="verificarVtnFinalizada() && $route.name === 'gerenciamento-daes' && isPara && vtn.temExcedente"
    v-for="(vtnEx, index) in resumoExcedentes"
    ).card-info
      el-row
        div.d-flex.tb
          div.column
            p.verde-text.text-aviso {{vtnEx.tituloExcedente}}
            p.verde-text.text-between {{vtnEx.mensagemExcedente}}
          div.botao
            el-button.green.textButtonBreak(
              v-if="vtnEx.vencido"
              tipo="success",
              @click="reemiteExcedente()"
            )
              span.center
                i.fal.fa-credit-card
                | &nbsp Reemitir DAE
            el-button.green.textButtonBreak(
              tipo="success",
              v-if="hasVtn"
              @click="goLink(true, index)"
            )
              span.center
                i.fal.fa-credit-card
                | &nbsp {{vtnEx.mensagemBotaoExcedente}}

</template>

<script>
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {

  data () {
    return {
      daesBoleto: null,
      protocolo: null,
      vtn: null,
      vtnExcedente: null,
      dadosVtn: null,
      processo: null,
      isVencido: true,
      isAmapa: process.env.ESTADO === 'ap',
      isPara: process.env.ESTADO === 'pa',
      isVisualizarVtn: '',
      hasVtn: false,
      isRoraima: process.env.ESTADO === 'rr',
      excedente: false,
      resumoExcedentes: []
    }
  },
  mixins: [
    AppNotificacao
  ],
  async created () {
    this.protocolo = this.$route.params.idCadastro
  },

  async beforeUpdate () {
    if (this.vtn !== '' && !this.isAmapa && !this.isRoraima && !this.isPara) {
      this.dadosVtn = await axios({
        method: 'GET',
        url: `financeiro/vtn/${this.vtn.id}`
      })
    }
    if (this.isPara && this.vtn) {
      this.dadosVtn = await axios({
        method: 'GET',
        url: `financeiro/vtn/getParcelaExcedenteByIdVtn/${this.vtn.id}`,
        params: {
          excedente: this.excedente
        }
      })
    }
  },
  async mounted () {
    await this.getProcessoByProtocolo(this.$route.params.idCadastro).then((r) => {
      this.processo = r
    })
    this.vtn = await this.verificarVtn()
    if (this.vtn) {
      if (this.isPara) {
        this.isVisualizarVtn = true
        this.hasVtn = true
        const { vencido, temExcedente } = await axios({
          method: 'GET',
          url: `financeiro/vtn/verificaVTN/${this.protocolo}`
        })
        this.vtn = {
          ...this.vtn,
          vtnVencido: vencido,
          temExcedente: temExcedente
        }
        if (this.vtn.temExcedente) {
          this.excedente = true
          const response = await axios({
            method: 'GET',
            url: `financeiro/vtn/verificaVTNExcedente/${this.protocolo}`
          })
          this.resumoExcedentes.push(...response)
        }
      } else if (this.isAmapa || this.isRoraima) {
        this.hasVtn = this.vtn.status !== 'AGUARDANDO_CALCULO'
        this.isVisualizarVtn = this.vtn.status.toUpperCase() === 'FINALIZADO'
        if (this.isVisualizarVtn || this.vtn.status.toUpperCase() !== 'CRIADO') {
          this.vtn = {
            ...this.vtn,
            titulo: 'Seu VTN já está disponível',
            mensagem: 'Você já escolheu a forma de pagamento do seu VTN. Clique no botão ao lado para visualizar o resumo do VTN',
            mensagemBotao: 'Visualizar o resumo do VTN'
          }
        } else if ((this.vtn.status === 'Aguardando cálculo' || this.vtn.status.toUpperCase() === 'CRIADO') && this.processo.status === 'AGUARDANDO_CONFIRMACAO_INTERESSADO') {
          this.vtn = {
            ...this.vtn,
            titulo: 'Seu VTN já está disponível',
            mensagem: 'Clique no botão ao lado e escolha a forma de pagamento',
            mensagemBotao: 'Escolher forma de pagamento'
          }
        }
      }
    }
  },
  methods: {
    ...mapActions({
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      findDaes: 'dae/findDaesByNumeroProcesso'
    }),
    async reemite () {
      axios({
        method: 'POST',
        url: `financeiro/vtn/reemitirVTN/${this.protocolo}`
      }).then(async () => {
        this.vtn = await this.verificarVtn()
        this.$emit('reload')
      })
    },
    async reemiteExcedente () {
      axios({
        method: 'POST',
        url: `financeiro/vtn/reemitirVTNExcedente/${this.protocolo}`
      }).then(async () => {
        this.vtn = await this.verificarVtn()
        location.reload()
      })
    },
    goLink (excedente, index) {
      if (this.isAmapa || this.isRoraima) {
        this.$router.push({
          name: this.isAmapa ? 'vtn/escolher-forma-pagamento' : 'vtnrr/escolher-forma-pagamento',
          params: {
            vtn: this.vtn,
            processo: this.processo,
            isUsuarioExterno: true,
            isVisualizar: this.isVisualizarVtn
          }
        })
      } else {
        this.$router.push({
          name: 'calculo-pagamento',
          params: {
            idVtn: this.vtn.id,
            excedente: excedente,
            index: index
          }
        })
      }
    },
    async verificarVtn () {
      try {
        let url = ''
        if (!this.isAmapa || !this.isRoraima) {
          url = `financeiro/vtn/verificaVTN/${this.protocolo}`
        }
        if (this.isAmapa || this.isRoraima) {
          url = `analise/moduloVtn/vtn/processo/${this.processo.id}`
        }
        return await axios({
          method: 'GET',
          url: url
        })
      } catch (err) {
        console.error(err)
      }
    },
    verificarVtnFinalizada () {
      return this.isPara ? this.vtn && (this.vtn.aguardandoConfirmacaoInteressado || this.vtn.finalizado) : this.vtn !== null && this.vtn !== ''
    }
  }
}
</script>

<style scoped lang="scss">
.card-info {
  border-radius: 15px;
  background-color: #fff;
  border: solid 1px #009d64;
  margin: 2%;
  margin-bottom: -10px;
}

.d-flex {
  height: 90px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tb {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}

.verde-text {
  color: #009d64 !important;
}

.green {
  color: #ffffff;
  background-color: #009f61;
  height: 40px;
}

.textButtonBreak {
  white-space: break-spaces;
}

.text-between {
 flex-direction: column;
}

.center {
  display: flex;
  align-items: center;
}

.botao{
  justify-content: flex-end;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppAvisoVtn.vue